import { db } from './../../../config/Fire';
import * as Constants from './../../../constants/nodes_database';

export const SET_NEIGHBORHOODS = 'SET_NEIGHBORHOODS';

const setNeighborhood = payload => ({ type: SET_NEIGHBORHOODS, payload });

export const setNeighborhoodToState = payload => {
    return dispatch => {
        return db.ref(`${Constants.NEIGHBORHOODS}`).once("value")
            .then((snapshot) => {
                if(snapshot.exists() && snapshot.val() !== null) {
                    var neighborhoods = {};
                    snapshot.forEach(function(neighborhood) {
                        var neighborhoodVal = neighborhood.val();
                        neighborhoods[neighborhoodVal.id] = neighborhoodVal.name;
                    });
                    dispatch(setNeighborhood(neighborhoods));
                } else {
                    console.log("snapshot: " + snapshot);
                    dispatch(setNeighborhood(null));
                }
            })
            .catch(err => {
                console.log ('Error getting user: ', err);
                dispatch(setNeighborhood(null));
        });
    };
};